import React from "react";
import { Button, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import RonadIcons from "../iconComponent";

const TicketLink = () => {
    return (
        <Link to="/alltickets/"
            style={{ pointerEvents: process.env.REACT_APP_ENVIROMENT == "sandbox" ? "none" : "auto" }}>
            <Button
                style={{ marginRight: "8px" }}
                size="large"
                variant="outlined"
                disabled={process.env.REACT_APP_ENVIROMENT == "sandbox"}
                color="primary">
                <Typography style={{ display: "flex" }}>
                    <RonadIcons name="headset" size={1} style={{ marginLeft: "5px" }} />
                    <span>پشتیبانی</span>
                </Typography>
            </Button>
        </Link>
    )
}

export default TicketLink;